var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rb-plp-wishlist-modal_content" }, [
    _c("div", { staticClass: "rb-plp-wishlist-modal_content--title" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("plp.plp_wishlist_modal.title")))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "rb-plp-wishlist-modal_content--description" }, [
      _c("span", [
        _vm._v(_vm._s(_vm.$t("plp.plp_wishlist_modal.description"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "rb-plp-wishlist-modal_content--cta" }, [
      _c(
        "button",
        {
          staticClass: "rb-btn rb-btn--black",
          on: {
            click: function ($event) {
              return _vm.$emit("closed")
            },
          },
        },
        [
          _c("a", { attrs: { href: _vm.loginUrl } }, [
            _vm._v(_vm._s(_vm.$t("plp.plp_wishlist_modal.cta"))),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }